import { warehouseClient } from "@/infrastructure/http/warehouseClient";
import type { ApiEnvelope } from "@/domain/types";

export interface DashboardData {
  movementsByDay: { date: string; inflows: number; outflows: number }[];
  topProducts: { productId: string; productName: string; totalMovements: number }[];
  warehouseOccupancy: { warehouseId: string; warehouseName: string; totalCapacity: number; currentStock: number; percentage: number }[];
  stockByWarehouse: { warehouseId: string; warehouseName: string; totalUnits: number; totalProducts: number }[];
}

export async function getDashboard(from: string, to: string): Promise<DashboardData> {
  const response = await warehouseClient.get<ApiEnvelope<DashboardData>>(`/analytics/dashboard?from=${from}&to=${to}`);
  return response.data.data;
}
